module.exports = __webpack_public_path__ + "static/media/airbnb.ea0ff53e.png";